// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--2Yefr","author__bio-twitter":"Author-module--author__bio-twitter--n-O9n"};